import tw from './tw'

import { getStore } from '../utils/encrypt'

const t = str => {
  const lang = getStore('locale') || 'zh'

  if (lang == 'zh') return str

  if (lang == 'tw') {
    const twValue = tw[str]
    return twValue || str
  }
}
export default t
